import * as React from 'react';

const PendingCircleFilled16: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
		<path
			d='M8 1C11.8661 1 15 4.13385 15 8C15 11.8661 11.8661 15 8 15C4.13385 15 1 11.8661 1 8C1 4.13385 4.13385 1 8 1ZM8 3.84615C7.80094 3.84615 7.61009 3.92523 7.4695 4.06582C7.3289 4.20642 7.24985 4.39727 7.24985 4.59631V8.00008C7.24985 8.41373 7.58594 8.74981 8.00008 8.74981H10.7693C10.9683 8.74981 11.1592 8.67076 11.2998 8.53016C11.4404 8.38957 11.5194 8.19872 11.5194 7.99969C11.5194 7.80065 11.4404 7.6098 11.2998 7.4692C11.1592 7.32861 10.9683 7.24956 10.7693 7.24956H8.75031V4.59631C8.75031 4.39727 8.67126 4.20642 8.53066 4.06582C8.39007 3.92523 8.19922 3.84615 8 3.84615Z'
			fill='#D97F18'
		/>
	</svg>
);

export default PendingCircleFilled16;
